export default __webpack_public_path__ + "static/media/percentile-icon.5fae32a8.svg";